module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image11.6e8bfe58.webp";